export default __webpack_public_path__ + "static/media/close_icon.d558be9f.svg";